import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { NgMaterialModule } from '../../shared/ng-material/ng-material.module';
import { FilterModule } from '../filter/filter.module';
import { ControlListRoutingModule } from './control-list-routing.module';
import { ControlListComponent } from './control-list.component';

@NgModule({
  declarations: [
    ControlListComponent
  ],
  imports: [
    CommonModule,
    ControlListRoutingModule,
    NgMaterialModule,
    FormsModule,
    FilterModule
  ]
})
export class ControlListModule { }
